"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithdrawalUnavailableDisclaimer = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, dangerouslySetInnerHTML: { __html: text } }));
};
exports.default = WithdrawalUnavailableDisclaimer;
